import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "star"];

  select() {
    const selected = Number.parseInt(
      this.inputTargets.find((input) => input.checked)?.value || 0,
    );

    this.starTargets.forEach((star) => {
      const value = Number.parseInt(star.dataset.value);
      star.classList.toggle("text-amber-500", value <= selected);
      star.classList.toggle("text-gray-300", value > selected);
    });
  }
}
